// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69a5e8d8","239":"ad40150f","453":"8701dc61","455":"d84a77af","879":"317534eb"}[chunkId] + ".chunk.js";
};